import React, { Component, useId } from "react";
import apiInstance from "../apiInstance";
import PopupModal from "./popups/PopupModal";
import { connect } from "react-redux";
import { changeCurrentUser } from "../../state/actionCreators/index";
import UserDetails from "./UserDetails";
import ResenMailPopup from "../Popups/ResenMailPopup";

// Main component for managing users in admin panel
class DeavadminUsers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      users: [],
      selectedUser: null,
      popupModal: React.createRef(),
      verifyMailPopupRef: React.createRef(),
      error: "",
      messagesShowing: {},
      filteredUsers: [],
      searchTerm: "",
      selectedRole: "",
    };
  }

  // Fetch users on mount
  componentDidMount() {
    apiInstance
      .get("/devadmin/user")
      .then((response) => {
        this.setState({
          users: response.data.users,
          filteredUsers: response.data.users,
        });
      })
      .catch((error) => {
        console.log("Error in User :" + error.message);
      });
  }

  // Add user to state
  addUser = (user) => {
    this.setState((prevState) => {
      const updatedUsers = [...prevState.users, user];
      return {
        users: updatedUsers,
        filteredUsers: this.filterUsers(
          updatedUsers,
          prevState.searchTerm,
          prevState.selectedRole
        ),
      };
    });
  };

  // Update user in state
  updateUser = (updatedUser) => {
    this.setState((prevState) => {
      const updatedUsers = prevState.users.map((user) =>
        user.id === updatedUser.id ? updatedUser : user
      );
      return {
        users: updatedUsers,
        filteredUsers: this.filterUsers(
          updatedUsers,
          prevState.searchTerm,
          prevState.selectedRole
        ),
      };
    });
  };

  // Remove user from state
  deleteUser = (userId) => {
    this.setState((prevState) => {
      const updatedUsers = prevState.users.filter((user) => user.id !== userId);
      return {
        users: updatedUsers,
        filteredUsers: this.filterUsers(
          updatedUsers,
          prevState.searchTerm,
          prevState.selectedRole
        ),
      };
    });
  };

  // Switch to user account
  switchUser = (userId) => {
    apiInstance
      .get(`/devadmin/user/${userId}`)
      .then((response) => {
        const user = response.data.user;
        const adminId = localStorage.getItem("userId");
        const adminToken = localStorage.getItem("token");

        // Store current admin credentials and set user credentials
        localStorage.setItem("token", user.token);
        localStorage.setItem("userId", user.id);
        sessionStorage.setItem("adminToken", adminToken);
        sessionStorage.setItem("adminId", adminId);
        sessionStorage.setItem("userSwitched", true);

        this.props.changeCurrentUser(user);
        window.location.href = "/home";
      })
      .catch((error) => {
        console.log("Error : " + error.message);
      });
  };

  // Show user details
  openUserDetail = (user) => {
    this.setState({ selectedUser: user });
  };

  // Close user details
  closeUserDetail = () => {
    this.setState({ selectedUser: null });
  };

  // Handle delete user from button
  handleDeleteUser = (e) => {
    const userId = e.target.getAttribute("data-id");
    this.state.popupModal.current.openPopup("deleteUser", { userId });
  };

  // Handle edit user from button
  handleEditUser = (e) => {
    let user = e.target.getAttribute("data-user");
    user = JSON.parse(user);
    this.state.popupModal.current.openPopup("updateUser", { user });
  };

  handleEmailVerification = (email, userId) => {
    const request_body = {
      email: email,
    };

    apiInstance
      .post("/user/verifyEmailRequest", request_body)
      .then((response) => {
        this.setState((prevState) => ({
          success: true,
          error: null,
          fieldErrors: null,
          messagesShowing: {
            ...prevState.messagesShowing,
            [userId]: true,
          },
        }));

        setTimeout(() => {
          this.setState((prevState) => ({
            messagesShowing: {
              ...prevState.messagesShowing,
              [userId]: false,
            },
          }));
        }, 2000);
      })
      .catch((error) => {
        this.setState({
          fieldErrors: error.response?.data?.fieldErrors || null,
          error: null,
        });
      });
  };
  // Filter users based on search term and role
  filterUsers = (users, searchTerm, selectedRole) => {
    return users.filter((user) => {
      const matchesSearch =
        searchTerm === "" ||
        (user.displayName &&
          user.displayName.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (user.email &&
          user.email.toLowerCase().includes(searchTerm.toLowerCase()));
      const matchesRole =
        selectedRole === "" ||
        (user.userRole && user.userRole === selectedRole) ||
        (!user.userRole && selectedRole === "customer");
      return matchesSearch && matchesRole;
    });
  };
  // Handle search input change
  handleSearchChange = (e) => {
    const searchTerm = e.target.value;
    this.setState((prevState) => ({
      searchTerm: searchTerm,
      filteredUsers: this.filterUsers(
        prevState.users,
        searchTerm,
        prevState.selectedRole
      ),
    }));
  };

  // Handle role filter change
  handleRoleChange = (e) => {
    const selectedRole = e.target.value;
    this.setState((prevState) => ({
      selectedRole: selectedRole,
      filteredUsers: this.filterUsers(
        prevState.users,
        prevState.searchTerm,
        selectedRole
      ),
    }));
  };

  render() {
    const { filteredUsers, selectedUser, searchTerm, selectedRole } =
      this.state;

    return (
      <div className="mjwidev-main">
        {!selectedUser && (
          <div className="mjwidev-main-top">
            <h2>All Users</h2>
            <div
              className="mjwidev-add-user-btn mjwi-btn mjwidev-addnew"
              onClick={() => this.state.popupModal.current.openPopup("addUser")}
            >
              Add New User
            </div>
          </div>
        )}
        {!selectedUser && (
          <div className="mjwidev-filter-wrapper">
            <div className="mjwidev-input-field mjwidev-width-40 ">
              <input
                type="text"
                placeholder="Search User"
                value={searchTerm}
                onChange={this.handleSearchChange}
              />
            </div>
            <div  className="mjwidev-input-field custom-select-wrapper mjwidev-width-40">
              <select value={selectedRole} onChange={this.handleRoleChange}>
                <option value="">All Roles</option>
                <option value="admin">Admin</option>
                <option value="customer">Customer</option>
              </select>
              <div className="custom-arrow mjwidev-top-30">
                <svg
                  fill="#ffffff"
                  height="16px"
                  width="16px"
                  viewBox="0 0 330 330"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M325.607,79.393c-5.857-5.857-15.355-5.858-21.213,0.001l-139.39,139.393L25.607,79.393 
                        c-5.857-5.857-15.355-5.858-21.213,0.001c-5.858,5.858-5.858,15.355,0,21.213l150.004,150c2.813,2.813,6.628,4.393,10.606,4.393 
                        s7.794-1.581,10.606-4.394l149.996-150C331.465,94.749,331.465,85.251,325.607,79.393z"
                  ></path>
                </svg>
              </div>
            </div>
          </div>
        )}

        {!selectedUser ? (
          // Users list table
          <div className="mjwi-setting-page mjwi-subscription-page">
            <table className="mjwidev-table" border="1">
              <thead>
                <tr>
                  <th>Verified</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Role</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredUsers.map((user, index) => (
                  <tr className="mjwi-subscription-table-row" key={index}>
                    <td style={{ position: "relative" }}>
                      {user.emailVerified ? (
                        <i
                          title="Email verified"
                          className="fa-solid fa-circle-check"
                          style={{ color: "green" }}
                        ></i>
                      ) : (
                        <i
                          onClick={() => {
                            this.handleEmailVerification(user.email, user.id);
                          }}
                          title="Email not verified"
                          className="fa-solid fa-circle-exclamation"
                          style={{ color: "red", cursor: "pointer" }}
                        ></i>
                      )}
                      {this.state.messagesShowing[user.id] && (
                        <div className="floating-message">
                          Email sent successfully!
                        </div>
                      )}
                    </td>

                    <td
                      style={{ cursor: "pointer" }}
                      onClick={() => this.openUserDetail(user)}
                    >
                      {user.displayName}
                    </td>
                    <td
                      style={{ cursor: "pointer" }}
                      onClick={() => this.openUserDetail(user)}
                    >
                      {user.email}
                    </td>
                    <td
                      style={{ cursor: "pointer" }}
                      onClick={() => this.openUserDetail(user)}
                    >
                      {user?.userRole || "customer"}
                    </td>
                    <td>
                        <i
                            onClick={(e) => {
                            e.stopPropagation();
                            this.state.popupModal.current.openPopup(
                                "updateUser",
                                { user }
                            );
                            }}
                            className="fa-solid fa-pen-to-square"
                        ></i>
                        <i
                            onClick={(e) => {
                            e.stopPropagation();
                            this.switchUser(user.id);
                            }}
                            className="fa-solid fa-eye"
                        ></i>
                        <i
                            onClick={(e) => {
                            e.stopPropagation();
                            this.state.popupModal.current.openPopup(
                                "deleteUser",
                                { userId: user.id }
                            );
                            }}
                            className="fa-solid fa-trash"
                        ></i>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          // User details view
          <UserDetails
            users={selectedUser}
            editUser={() => this.handleEditUser}
            deleteUser={() => this.handleDeleteUser}
            switchUser={this.switchUser}
            closeUserDetail={this.closeUserDetail}
            updateUser={this.updateUser}
            deleteUserMain={this.deleteUser}
          />
        )}
        <PopupModal
          ref={this.state.popupModal}
          addUser={this.addUser}
          updateUser={this.updateUser}
          deleteUser={this.deleteUser}
        />
        <ResenMailPopup ref={this.state.verifyMailPopupRef} />
      </div>
    );
  }
}

// Redux connection
const mapStateToProps = (state) => ({
  user: state.currentUser,
});

const mapDispatchToProps = (dispatch) => ({
  changeCurrentUser: (user) => dispatch(changeCurrentUser(user)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DeavadminUsers);
